let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("gZl9R")).then(() => parcelRequire('5F8C5'));